const customer = 'SPASOLUTION';
let currentProduct;
let iframeSrc;

const carousel = document.querySelector('.flickity-slider');
const thumbnailGallery = document.querySelector('.product-gallery__thumbnail-list');


const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50; // Check every 50ms
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});


const initializeScript = async () => {
    await waitForMazingFunction;

    console.log('MAZING is ready ...');
    
    /* AB SECTION START */

    // const waitForElement = (selector, timeout = 55000) => {
    //     return new Promise((resolve) => {
    //         const interval = 50;
    //         let elapsedTime = 0;
    //         const checkInterval = setInterval(() => {
    //             const element = document.querySelector(selector);
    //             if (element) {
    //                 clearInterval(checkInterval);
    //                 resolve(element);
    //             } else if ((elapsedTime += interval) >= timeout) {
    //                 clearInterval(checkInterval);
    //                 resolve();
    //             }
    //         }, interval);
    //     });
    // };

    // const addToCartSelector = 'button[data-action="add-to-cart"]';

    // await waitForElement(addToCartSelector);

    // mazingSetAB({
    //     enabled: true,
    //     addToCartListeners: (callback) => {
    //         document.querySelector(addToCartSelector).addEventListener('click', () => {
    //             console.log('MAZING: addToCartClicked A/B');
    //             callback();
    //         });
    //     }
    // });

    /* AB SECTION END */

    iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: () => {
            const url = window.location.href;
            const match = url.match(/\/products\/([^?]+)/);

            currentProduct = match ? match[1] : null;
            currentProduct = currentProduct.replace(/\/$/, '');
            console.log('extracted sku: ' + currentProduct);

            const selectedValue = document.querySelector('.product-form__selected-value');

            if (selectedValue && selectedValue.innerText.includes('#')) {
                const valueString = selectedValue.innerText;
                const cleanedValue = valueString.replace('#', '');
                currentProduct += `-${cleanedValue}`
            }

            const sizeSelect = document.querySelector('select.product-form__single-selector');
            if (sizeSelect) {
                const selectedOption = sizeSelect.querySelector('option[selected]');
                if (selectedOption) {
                    const selectedSize = selectedOption.value.trim().replace(/\s/g, '');
                    if (selectedSize) {
                        currentProduct += `-${selectedSize.toLowerCase()}`;
                    }
                }
            }

            console.log('Final World Product: ', currentProduct)

            return currentProduct;
        }
    });


    if (!iframeSrc) {
        console.log('iframeSrc not found, aborting script execution.');
        return;
    }

    const iframeDiv = document.createElement('div');
    iframeDiv.className = 'product-gallery__carousel-item';
    iframeDiv.style.height = '480px';
    iframeDiv.style.width = '100%';
    iframeDiv.style.position = 'absolute';
    iframeDiv.style.left = '-50%';
    iframeDiv.style.opacity = '1';
    iframeDiv.id = 'mazing-div';

    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.border = 'none';

    iframeDiv.appendChild(iframe);

    const thumbnailElement = document.createElement('a');
    thumbnailElement.className = 'product-gallery__thumbnail'; // add is-nav-selected for active new thumb
    thumbnailElement.style.height= '70px';
    thumbnailElement.id= 'mazing-thumb';

    const thumbnailDiv = document.createElement('div');
    thumbnailDiv.className = 'aspect-ratio';
    thumbnailDiv.style.height = '100%';

    const svgImgIcon = document.createElement('img');
    svgImgIcon.className = 'image--fade-in lazyloaded';
    svgImgIcon.setAttribute('data-src', 'https://cdn.mazing.link/assets/svg/3D.svg');
    svgImgIcon.setAttribute('alt', 'Mazing Viewer');
    svgImgIcon.src = 'https://cdn.mazing.link/assets/svg/3D.svg';
    svgImgIcon.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';
    svgImgIcon.style.padding = '15%';


    thumbnailDiv.appendChild(svgImgIcon);
    thumbnailElement.appendChild(thumbnailDiv);

    if (thumbnailGallery) {
        //
        // const firstThumbnail = thumbnailGallery.firstChild;
        //
        // if (firstThumbnail && firstThumbnail.tagName === 'A') {
        //     firstThumbnail.classList.remove('is-nav-selected');
        // }

        thumbnailGallery.insertBefore(thumbnailElement, thumbnailGallery.firstChild.nextSibling)
    }

    if (carousel) {
        //
        // const firstCarouselItem = document.querySelector('.product-gallery__carousel-item.is-selected'); // add .is-selected for active div
        //
        // if (firstCarouselItem) {
        //     firstCarouselItem.className = 'product-gallery__carousel-item product-gallery__carousel-item--hidden'
        //     firstCarouselItem.setAttribute('aria-hidden', 'true');
        // }

        carousel.insertBefore(iframeDiv, carousel.firstChild.nextSibling);
    }

    const ensureZoomNoticeVisibility = () => {
        const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
        const isIframeSelected = thumbnailElement.classList.contains('is-nav-selected');

        if (zoomNotice) {
            zoomNotice.style.display = isIframeSelected ? 'none' : '';
        }
    };


    const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');
    const flickityViewport = document.querySelector('.flickity-viewport');

    allThumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
            allThumbnails.forEach(thumb => thumb.classList.remove('is-nav-selected'));

            thumbnail.classList.add('is-nav-selected');

            const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
            allCarouselItems.forEach(item => {
                item.classList.add('item--hidden');
                item.classList.remove('is-selected')
                item.setAttribute('aria-hidden', 'true');
            });

            const selectedCarouselItem = allCarouselItems[index];
            if (selectedCarouselItem) {
                selectedCarouselItem.classList.remove('item--hidden');
                selectedCarouselItem.classList.add('is-selected');
                selectedCarouselItem.removeAttribute('aria-hidden');
            }


            if (thumbnail === thumbnailElement) {
                flickityViewport.style.height = '480px';
            } else {
                flickityViewport.style.height = '';
            }

            ensureZoomNoticeVisibility();
        });
    });

    //thumbnailElement.click(); // if new insert div needs to activated
    ensureZoomNoticeVisibility();

    // const productVariants = document.querySelector('.product-form__variants');
    // let colorsContainer;
    // let colors;

    // if (productVariants) {
    //   colorsContainer = productVariants.querySelector('.color-swatch-list');
    //   if (colorsContainer) {
    //      colors = colorsContainer.querySelectorAll('.color-swatch');             
    //   }
    // }

    // if (colors) {
    //   colors.forEach(div => {
    //       const label = div.querySelector('.color-swatch__item');
  
    //       label.addEventListener('click', async () => {
    //           const colorValue = label.getAttribute('title');
    //           console.log('COLOR VALUE:', colorValue);
    //           if (!colorValue) return;
  
    //           const cleanColor = colorValue.replace('#', '');
  
    //           const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
    //           const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');
  
    //           const mazingThumb = document.getElementById('mazing-thumb');
    //           const mazingDiv = document.getElementById('mazing-div');
  
    //           if (mazingThumb) mazingThumb.classList.remove('is-nav-selected');
    //           if (mazingDiv) {
    //               mazingDiv.classList.add('item--hidden');
    //               mazingDiv.classList.remove('is-selected');
    //               mazingDiv.setAttribute('aria-hidden', 'true');
    //           }
  
    //           for (let i = 0; i < allThumbnails.length; i++) {
    //               const thumb = allThumbnails[i];
    //               const item = allCarouselItems[i];
  
    //               if (thumb !== mazingThumb) {
    //                   thumb.classList.add('is-nav-selected');
    //                   item.classList.remove('item--hidden');
    //                   item.classList.add('is-selected');
    //                   item.removeAttribute('aria-hidden');
    //                   break;
    //               }
    //           }
  
    //           const flickityViewport = document.querySelector('.flickity-viewport');
    //           if (flickityViewport) flickityViewport.style.height = '';
  
    //           const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
    //           if (zoomNotice) zoomNotice.style.display = '';
  
    //           // set new iframeSrc
    //           const newIframeSrc = await mazingProjectAvailable({
    //               customerName: customer,
    //               getSKU: () => {
    //                   const url = window.location.href;
    //                   const match = url.match(/\/products\/([^?]+)/);
  
    //                   currentProduct = match ? match[1] : null;
    //                   currentProduct = currentProduct.replace(/\/$/, '');
    //                   console.log('extracted sku: ' + currentProduct);
  
    //                   const newSku = `${currentProduct}-${cleanColor}`;
    //                   console.log('new sku: ' + `${currentProduct}-${cleanColor}`);
  
    //                   return newSku.toLowerCase();
    //               }
    //           });
  
    //           if (newIframeSrc) {
    //               iframeSrc = newIframeSrc;
    //               const iframe = document.querySelector('#mazing-div iframe');
    //               if (iframe) {
    //                   iframe.src = newIframeSrc;
    //               }
    //           } else {
    //               console.log('No Mazing Project found! Return;')
    //           }
    //       });
    //   });      
    // }

    const productVariants = document.querySelector('.product-form__variants');
    let colorsContainer;
    let colors;
    let colorSelect;
    
    if (productVariants) {
      colorsContainer = productVariants.querySelector('.color-swatch-list');
      if (colorsContainer) {
        colors = colorsContainer.querySelectorAll('.color-swatch');
      } else {
        // Kein Color-Swatch -> prüfen, ob ein Select existiert
        colorSelect = productVariants.querySelector('.product-form__single-selector');
      }
    }
    
    async function handleColorChange(colorValue) {
      console.log('COLOR VALUE:', colorValue);
      if (!colorValue) return;
    
      const cleanColor = colorValue.replace('#', '').replace(/\s+/g, '').toLowerCase(); // Leerzeichen entfernen
    
      const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
      const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');
    
      const mazingThumb = document.getElementById('mazing-thumb');
      const mazingDiv = document.getElementById('mazing-div');
    
      if (mazingThumb) mazingThumb.classList.remove('is-nav-selected');
      if (mazingDiv) {
        mazingDiv.classList.add('item--hidden');
        mazingDiv.classList.remove('is-selected');
        mazingDiv.setAttribute('aria-hidden', 'true');
      }
    
      for (let i = 0; i < allThumbnails.length; i++) {
        const thumb = allThumbnails[i];
        const item = allCarouselItems[i];
    
        if (thumb !== mazingThumb) {
          thumb.classList.add('is-nav-selected');
          item.classList.remove('item--hidden');
          item.classList.add('is-selected');
          item.removeAttribute('aria-hidden');
          break;
        }
      }
    
      const flickityViewport = document.querySelector('.flickity-viewport');
      if (flickityViewport) flickityViewport.style.height = '';
    
      const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
      if (zoomNotice) zoomNotice.style.display = '';
    
      // set new iframeSrc
      const newIframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: () => {
          const url = window.location.href;
          const match = url.match(/\/products\/([^?]+)/);
    
          let currentProduct = match ? match[1] : null;
          currentProduct = currentProduct.replace(/\/$/, '');
          console.log('extracted sku: ' + currentProduct);
    
          const newSku = `${currentProduct}-${cleanColor}`;
          console.log('new sku: ' + newSku);
    
          return newSku;
        }
      });
    
      if (newIframeSrc) {
        iframeSrc = newIframeSrc;
        const iframe = document.querySelector('#mazing-div iframe');
        if (iframe) {
          iframe.src = newIframeSrc;
        }
      } else {
        console.log('No Mazing Project found! Return;');
      }
    }
    
    if (colors) {
      // CASE 1: Farb-Swatches
      colors.forEach(div => {
        const label = div.querySelector('.color-swatch__item');
    
        label.addEventListener('click', () => {
          const colorValue = label.getAttribute('title');
          handleColorChange(colorValue);
        });
      });
    } else if (colorSelect) {
      // CASE 2: Dropdown-Auswahl
      colorSelect.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const colorValue = selectedOption.value;
        handleColorChange(colorValue);
      });
    }



    // --- HANDLE SIZE DROPDOWN SELECTION ---
    const sizeSelect = productVariants.querySelector('select.product-form__single-selector');
    
    if (sizeSelect) {
        sizeSelect.addEventListener('change', async () => {
            const selectedSize = sizeSelect.value.trim();
            console.log('SELECTED SIZE:', selectedSize);
    
            const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
            const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');
    
            const mazingThumb = document.getElementById('mazing-thumb');
            const mazingDiv = document.getElementById('mazing-div');
    
            if (mazingThumb) mazingThumb.classList.remove('is-nav-selected');
            if (mazingDiv) {
                mazingDiv.classList.add('item--hidden');
                mazingDiv.classList.remove('is-selected');
                mazingDiv.setAttribute('aria-hidden', 'true');
            }
    
            for (let i = 0; i < allThumbnails.length; i++) {
                const thumb = allThumbnails[i];
                const item = allCarouselItems[i];
    
                if (thumb !== mazingThumb) {
                    thumb.classList.add('is-nav-selected');
                    item.classList.remove('item--hidden');
                    item.classList.add('is-selected');
                    item.removeAttribute('aria-hidden');
                    break;
                }
            }
    
            const flickityViewport = document.querySelector('.flickity-viewport');
            if (flickityViewport) flickityViewport.style.height = '';
    
            const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
            if (zoomNotice) zoomNotice.style.display = '';
    
            // set new iframeSrc
            const newIframeSrc = await mazingProjectAvailable({
                customerName: customer,
                getSKU: () => {
                    const url = window.location.href;
                    const match = url.match(/\/products\/([^?]+)/);
                    currentProduct = match ? match[1] : null;
                    currentProduct = currentProduct.replace(/\/$/, '');
    
                    const cleanSize = selectedSize.replace(/\s/g, '').toLowerCase();
                    const newSku = `${currentProduct}-${cleanSize}`;
    
                    console.log('New SKU with size:', newSku);
                    return newSku;
                }
            });
    
            if (newIframeSrc) {
                iframeSrc = newIframeSrc;
                const iframe = document.querySelector('#mazing-div iframe');
                if (iframe) {
                    iframe.src = newIframeSrc;
                }
            } else {
                console.log('No Mazing Project found for this size. Return;')
            }
        });
    }


};

initializeScript();
